import React, {useState} from 'react';
import {uploadComplainceDocument} from "../../Api/Api";
import {useNotification} from "../Notification/NotificationContext";

const UploadComplianceModal = ({ show, asset, onClose }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [documentType, setDocumentType] = useState('');
    const [uploading, setUploading] = useState(false);
    const { showNotification } = useNotification();

    const documentTypes = [ "INVOICE", "UNION_LETTER", "LICENSE", "FORM_21",
        "FORM_22", "FORM_20", "INSURANCE", "RTO_SLIP", "REGISTRATION", "RC_ISSUED", "RC_HANDED_OVER"]

    if (!show || !asset) return null;

    const handleFileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    };

    const handleUpload = async () => {
        if (!selectedFile || !documentType) {
            showNotification("Please select a document type and file to upload.", "error");
            return;
        }

        const formData = new FormData();
        formData.append('file', selectedFile);
        formData.append('documentType', documentType);

        try {
            setUploading(true);
            uploadComplainceDocument(asset.assetId, formData)
            showNotification("Uploaded Successfully.", "success");
            onClose();
        } catch (error) {
            console.error(error);
            showNotification("Failed to upload document. Please try again.", "error");
        } finally {
            setUploading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg w-full max-w-md p-6">
                <h2 className="text-xl font-semibold mb-4">Upload Compliance Document</h2>

                <div className="mb-4">
                    <label className="block mb-1 text-sm font-medium text-gray-700">Asset</label>
                    <div className="p-2 border rounded">{asset.type} - {asset.serialNumber}</div>
                </div>

                <div className="mb-4">
                    <label className="block mb-1 text-sm font-medium text-gray-700">Document Type</label>
                    <select
                        value={documentType}
                        onChange={(e) => setDocumentType(e.target.value)}
                        className="w-full border px-3 py-2 rounded"
                    >
                        <option value="">Select Document Type</option>
                        {documentTypes.map((type) =>
                            <option value={type}>{type}</option>
                        )}
                        {/* Add more types if needed */}
                    </select>
                </div>

                <div className="mb-4">
                    <label className="block mb-1 text-sm font-medium text-gray-700">Select File</label>
                    <input
                        type="file"
                        onChange={handleFileChange}
                        className="w-full"
                        accept="image/jpeg,image/png,application/pdf"
                    />
                </div>

                <div className="flex justify-end space-x-2 mt-6">
                    <button
                        onClick={onClose}
                        className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
                        disabled={uploading}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleUpload}
                        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                        disabled={uploading}
                    >
                        {uploading ? 'Uploading...' : 'Upload'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UploadComplianceModal;
